import React, { useState } from 'react'
import CartItem from './CartItem'
import { setVoucherCode, loadCart, placeOrder, setOrderInstructions } from '../redux/actions/cart';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { callWaiter } from '../redux/actions/table';
import { formatPrice, hideVoucherCode } from '../common/Functions';

function Cart({ items, order, cartDetails, setVoucherCode, loadCart, error, voucherCode, setOrderInstructions, order_instruction, callWaiter,
    isVoucherApplied }) {

    const history = useHistory();
    const [waiterCalled, setWaiterCalled] = useState(false);

    const applyVoucher = () => {
        loadCart();
    }

    const callWaiterFn = () => {
        callWaiter();
        setWaiterCalled(true);
        setTimeout(() => {
            setWaiterCalled(false);
        }, 5000);

    }

    const removeVoucher = () => {
        setVoucherCode("");
        loadCart();
    }

    const showVoucher = hideVoucherCode();

    return (
        <div className="cart-item-details">
            {/*<div className="resturant-name active"><span className="fa fa-caret-down"></span> <span className="fa fa-caret-right"></span>
                <h3>Current Order<span className="item-count">(1 items)</span> <span className="total"> 140</span>
                </h3>
    </div>*/}

            <div className="added-item-content active">
                <div className="added-items-list">
                    {items && items.map((item, index) => <CartItem item={item} key={index} keyIndex={index} />)}
                </div>
                <div className="order-info">
                    <div className="bill-calculations">
                        <div className="bill-top border-bottom">
                            <div className="input-row">
                                <div className="col-2">Item Total</div>
                                <div className="col-2 text-right"> {formatPrice(cartDetails?.cart?.subtotal?.amount_pretty)}</div>
                            </div>
                            {cartDetails?.cart?.discount?.map((extra, index) => <div className="input-row" key={index}>
                                <div className="col-2">{extra.type}</div>
                                <div className="col-2 text-right"> {formatPrice(extra.amount_pretty)}</div>
                            </div>)}
                            {cartDetails?.cart.extra.map((extra, index) => <div className="input-row" key={index}>
                                <div className="col-2">{extra.type}</div>
                                <div className="col-2 text-right">{formatPrice(extra.amount_pretty)}</div>
                            </div>)}
                        </div>
                        <div className="grand-total-calculation">
                            <div className="input-row">
                                <div className="col-2 font-bold">Grand Total</div>
                                <div className="col-2 text-right font-bold">{formatPrice(cartDetails?.cart?.grand_total?.amount_pretty)}</div>
                            </div>
                        </div>
                    </div>
                    {showVoucher && <div className="promo-code">
                        <div className="input-row">
                            <div className="col-2 p-0">
                                <input className="form-input" type="text" placeholder="Add Promo Code"
                                    onChange={(e) => setVoucherCode(e.target.value)} value={voucherCode} />
                            </div>
                            {isVoucherApplied && <div className="col-2">
                                <a className="btn-apply-promo" onClick={removeVoucher}>Remove Promocode</a>
                            </div>

                            }
                            {!isVoucherApplied && <div className="col-2">
                                <a className="btn-apply-promo" onClick={applyVoucher}>Apply Promocode</a>
                            </div>}
                        </div>
                        {error && <div className="alert alert-danger">
                            {error}
                        </div>}
                    </div>}
                    <div className="addtional-info">
                        <textarea className="form-input" placeholder="Any additonal cooking instructions" rows="3"
                            value={order_instruction} onChange={(e) => setOrderInstructions(e.target.value)}></textarea>
                    </div>
                    <div className="mt-10">
                        <a className="text-white call-staff" onClick={callWaiterFn}>Call Staff</a>
                    </div>
                    {waiterCalled && <div className="alert alert-success" role="alert">
                        Your request has been sent. Someone will attend you shortly
</div>}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    error: state.cart.error,
    voucherCode: state.cart.voucherCode,
    order_instruction: state.cart.order_instruction,
    isVoucherApplied: state.cart.isVoucherApplied

})

export default connect(mapStateToProps, { setVoucherCode, loadCart, placeOrder, setOrderInstructions, callWaiter })(Cart)
